export function CameraIcon({ active }: any) {
  const color: string = active ? "#006AB3" : "#000000";
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99863 11.4006C10.3241 11.4006 11.3986 10.3261 11.3986 9.00059C11.3986 7.6751 10.3241 6.60059 8.99863 6.60059C7.67315 6.60059 6.59863 7.6751 6.59863 9.00059C6.59863 10.3261 7.67315 11.4006 8.99863 11.4006Z"
        stroke={color}
        stroke-width="0.833331"
      />
      <path
        d="M1 9.29124C1 6.83924 1 5.61364 1.5992 4.73364C1.85933 4.35096 2.19268 4.02359 2.58 3.77044C3.156 3.39204 3.8776 3.25684 4.9824 3.20884C5.5096 3.20884 5.9632 2.81684 6.0664 2.30884C6.14527 1.93673 6.35018 1.60327 6.64652 1.3648C6.94286 1.12633 7.31244 0.997484 7.6928 1.00004H10.3072C11.0976 1.00004 11.7784 1.54804 11.9336 2.30884C12.0368 2.81684 12.4904 3.20884 13.0176 3.20884C14.1216 3.25684 14.8432 3.39284 15.42 3.77044C15.808 4.02484 16.1416 4.35204 16.4008 4.73364C17 5.61364 17 6.83924 17 9.29124C17 11.7424 17 12.968 16.4008 13.8488C16.1402 14.2311 15.807 14.5584 15.42 14.812C14.5232 15.4 13.2744 15.4 10.7776 15.4H7.2224C4.7256 15.4 3.4768 15.4 2.58 14.812C2.19323 14.5581 1.86023 14.2306 1.6 13.848C1.42661 13.5889 1.29864 13.3021 1.2216 13M14.6 6.60004H13.8"
        stroke={color}
        stroke-width="0.833331"
        stroke-linecap="round"
      />
    </svg>
  );
}
